import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
const BANNER = 'https://cdn.magicpatterns.com/uploads/asqQ9aecaY66R61hn7XjpG/Banner_Julio.png';
const stats = [{
  value: '10+',
  labelKey: 'hero.stat1'
}, {
  value: '250+',
  labelKey: 'hero.stat2'
}, {
  value: '$0',
  labelKey: 'hero.stat3'
}];
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative isolate w-full overflow-hidden bg-navy-900" data-id="element-145" data-mp="xbpc32nfnudg">
      <img src={BANNER} alt="Recently completed two-story home with new roof, stone and siding exterior in Northwest Houston" className="absolute inset-0 h-full w-full object-cover object-center" loading="eager" data-id="element-146" data-mp="sa9qn9hcfluj" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-950/60 via-transparent to-transparent" aria-hidden="true" data-id="element-147" data-mp="3cz5uuafyvxzt" />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-950/80 via-transparent to-navy-950/40 sm:from-navy-950/40" aria-hidden="true" data-id="element-148" data-mp="3j9k9f79139e0" />

      <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-[124px] sm:px-6 sm:pb-20 sm:pt-[150px] lg:px-8 lg:pb-28 lg:pt-[190px]" data-id="element-149" data-mp="39alaige2es47">
        <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.55,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-150" data-mp="3e8ecex8c4zyo">
          <p className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur-sm sm:text-sm" data-id="element-151" data-mp="35aasg5d00b8z">
            <MapPinIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-152" data-mp="2vjzoiitbe223" />
            {t('hero.eyebrow')}
          </p>

          <h1 className="mt-6 font-display text-[34px] font-black leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[58px]" data-id="element-153" data-mp="2hjyp77sp72oq">
            {t('hero.title')}
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-154" data-mp="s2tcpjbm05oo">
            {t('hero.sub')}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-155" data-mp="n9i4bdr5fgun">
            <a href={BUSINESS.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-md bg-white px-6 py-4 font-display text-base font-bold text-navy-900 shadow-lift transition-[background-color,transform] duration-150 ease-smooth hover:bg-navy-50 active:scale-[0.98]" data-id="element-156" data-mp="ichz1524ii4l">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-157" data-mp="112pv537eo8ba" />
              {t('hero.call')}
            </a>
            <a href="#contact" className="inline-flex items-center justify-center gap-2 rounded-md bg-amber-600 px-6 py-4 font-display text-base font-bold text-white shadow-lift transition-[background-color,transform] duration-150 ease-smooth hover:bg-amber-700 active:scale-[0.98]" data-id="element-158" data-mp="x1nuqj1r5q7q">
              {t('hero.quote')}
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-159" data-mp="1xb5mo58pibbw" />
            </a>
          </div>

          <dl className="mt-12 grid max-w-xl grid-cols-3 gap-6 border-t border-white/15 pt-6" data-id="element-160" data-mp="218toztcqb6dt">
            {stats.map(stat => <div key={stat.labelKey} data-id="element-161" data-mp="2b0fxvj1lgtde">
                <dt className="sr-only" data-id="element-162" data-mp="2b1hgq9ouqk5o">{t(stat.labelKey)}</dt>
                <dd data-id="element-163" data-mp="2g0bzjbmtk8ps">
                  <span className="block font-display text-2xl font-extrabold text-amber-400 sm:text-3xl" data-id="element-164" data-mp="2fyr7bsnz91v3">
                    {stat.value}
                  </span>
                  <span className="mt-1 block text-xs font-medium text-white/70 sm:text-sm" data-id="element-165" data-mp="2p0qn6hn99zwg">
                    {t(stat.labelKey)}
                  </span>
                </dd>
              </div>)}
          </dl>
        </motion.div>
      </div>
    </section>;
}